var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:[
    'm-0',
    {
      'text-whiteboard-body-extra-small': _setup.isWhiteboard,
      'text-body-small-posts': _setup.xBigCaption,
      'text-body-extra-small': !_setup.xBigCaption,
    },

    'font-sans',
    'whitespace-break-spaces',
    {
      'text-dark-text-200 focus:text-dark-text-100': _vm.darkThemeType === 'browser' || !_vm.isDark,
      'dark:text-light-text-200 dark:focus:text-light-text-100': _vm.darkThemeType === 'browser',
      'text-light-text-200 focus:text-light-text-100': _vm.darkThemeType === 'custom' && _vm.isDark,
    },
  ],staticStyle:{"word-break":"break-word"},domProps:{"textContent":_vm._s(_vm.attachmentCaption)},on:{"click":function($event){return _vm.$emit('click', $event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click', $event)},"dblclick":function($event){return _vm.$emit('edit-start')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }